import { Modal, MODAL_SIZES } from 'components/ModalV2';
import { useLocationConsent } from 'hooks';
import { useTranslation } from 'react-i18next';
import { DropOffLocationsLayout } from '../../../../../../DropOffLocationLayout';
import { searchDropOffLocations } from '../../../services/getCollectionPoints.service';

export interface IViewAvailableDropOffLocationModalProps {
  onClose: () => void;
  isOpen: boolean;
  carrierId: string;
}

export const ViewAvailableDropOffLocationModal = ({
  onClose,
  isOpen,
  carrierId,
}: IViewAvailableDropOffLocationModalProps) => {
  const { t } = useTranslation();
  const { isAllowGoogleMaps } = useLocationConsent();
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      closable
      size={isAllowGoogleMaps ? MODAL_SIZES.lg : MODAL_SIZES.sm}
      aria={{
        labelledby: 'view-available-drop-off-location-modal-heading',
      }}
    >
      <Modal.Header id="view-available-drop-off-location-modal-heading">
        {t('RETURN_VIEW_AVAILABLE_DROPOFF_MODAL_HEADER')}
      </Modal.Header>
      <Modal.Body>
        <DropOffLocationsLayout
          searchDropOffLocationsFn={searchDropOffLocations}
          carrierId={carrierId}
        />
      </Modal.Body>
    </Modal>
  );
};
